import React from 'react';
import { ContextualAnalyticsData, MODAL } from '@atlassian/jira-product-analytics-bridge';

import { WorkflowViewDiagramModal, type Props } from './WorkflowViewDiagramModal.tsx';

const WorkflowViewDiagramModalApp = (props: Props): React.JSX.Element => {
	return (
		<ContextualAnalyticsData sourceName="workflowViewDiagram" sourceType={MODAL}>
			<WorkflowViewDiagramModal {...props} />
		</ContextualAnalyticsData>
	);
};

export default WorkflowViewDiagramModalApp;
